<mat-progress-bar mode="determinate" [value]="progress" color="accent"></mat-progress-bar>
